import moment from 'moment';
import consts from '../../../main/consts';
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

export default function validateCancelDate(date, isCec, dateReadyToGo) {
  const limit = moment(isCec ? dateReadyToGo : date).add(isCec ? consts.DAYS_TO_CANCEL_CEC :  consts.DAYS_TO_CANCEL, 'days');
  const prorrogateUntil = moment().isAfter(limit);

  return prorrogateUntil;
}

export function isEasterDate() {
  const localStartDate = "2026-03-30";
  const localEndDate = "2026-04-05";

    const today = dayjs();
    const startDate = dayjs(localStartDate);
    const endDate = dayjs(localEndDate);

    return today.isBetween(startDate, endDate);
  }